import { render, staticRenderFns } from "./CloseLead.vue?vue&type=template&id=23fdfd36&"
import script from "./CloseLead.vue?vue&type=script&lang=js&"
export * from "./CloseLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports